import React from "react";
import { View, Text } from "@react-pdf/renderer";
import { styles } from "../styles";
import { ProductLineItemLineInfo } from "./ProductLineItemLineInfo";
import { ProductLineDetails } from "./ProductLineDetails";

export const ProductLineItem = ({ order, position, product }) => (
  <View
    style={styles.productLineItem}
    wrap={false}
    key={`${position}-${product.model}`}
  >
    <ProductLineItemLineInfo position={position} product={product} />
    <ProductLineDetails order={order} product={product} />
    <Text style={styles.description}>{product.notes}</Text>
  </View>
);
